<template>
    <multiselect
        class="multiselectassign"
        v-model="editUser"
        placeholder="Unassigned"
        track-by="id"
        pre-select-first="false"
        :options="users"
        :show-labels="false"
        :custom-label="name"
        @open="showUsersList = true"
        @close="showUsersList = false"
        @input="userChanged"
        >

        <template slot="singleLabel" slot-scope="props" >

            <div class="row g-0" v-if="inline">
                <div class="col-auto d-flex align-items-center">
                    <img class="option__image" :src="getAvatar(props.option.id)" alt="" />
                </div>
                <div class="col d-flex align-items-center">
                    <div class="option__desc">
                        <span class="option__small">{{ props.option.name }}</span>
                    </div>
                </div>
            </div>

            <div v-else>
                <div class="avatar">
                    <img class="option__image" :src="getAvatar(props.option.id)" alt="" />
                </div>
                <p class="name">{{ props.option.name ? props.option.name.trimStart().split(" ")[0] : "" }}</p>
            </div>

        </template>




        <template slot="option" slot-scope="props">
            <div class="row g-0">
                <div class="col-auto d-flex align-items-center">
                    <img class="option__image" v-if="showUsersList" :src="getAvatar(props.option.id)" alt="" />
                </div>
                <div class="col d-flex align-items-center">
                    <div class="option__desc">
                        <span class="">{{ props.option.name }}</span>
                    </div>
                </div>
            </div><!-- /.row -->
        </template>

    </multiselect>

</template>

<script>

    import { mapState, mapActions, mapGetters } from 'vuex'
    import { filter, cloneDeep, debounce } from 'lodash'
    import Multiselect from 'vue-multiselect'

    export default {
        props: {
          user: {
            required: false
          },
          userChanged: {
            required: false
          },
          inline: {
            required: false,
            default: false
          },
          defaultClass: {
            required: false,
            default: 'multiselectassign',
            type: String
          },
        },

        components: {
            Multiselect
        },

        data: function () {
            return {
                showUsersList: false,
                editUser: {}
            }
        },

        watch: {
            user () {
                this.editUser = cloneDeep(this.user)
            },
        },

        mounted() {
            this.editUser = cloneDeep(this.user)
        },

        computed: {
            ...mapState('users', ['users'])
        },

        methods: {

            name: function(item) {
                return item.name
            },

            getAvatar: function(id) {
        		return process.env.VUE_APP_API_URL + '/user/' + id + '/avatar';
            },
        }
    }
</script>

<style >

</style>
